module.exports = __webpack_public_path__ + "static/expertiseHeader-718a59f4d8ba187943b729a192eb4e20.png";